import React from 'react';
import { PromoBanner } from '../components/PromoBanner';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { PacksSection } from '../components/PacksSection';
import { ProductCatalog } from '../components/ProductCatalog';
import { KnowYourCut } from '../components/KnowYourCut';
import { Footer } from '../components/Footer';
import { Cart } from '../components/Cart';
import { CartProvider } from '../context/CartContext';
import { CutsSlider } from '../components/CutsSlider';
import { ThemeProvider } from '../context/ThemeContext';
import { BurnTransition } from '../components/BurnTransition';
export function Home() {
  return <ThemeProvider data-id="element-228">
      <CartProvider data-id="element-229">
        <div className="min-h-screen" style={{
        backgroundColor: 'var(--color-pitch)',
        color: 'var(--color-ink)'
      }} data-id="element-230">
          <BurnTransition data-id="element-231" />
          <Navbar data-id="element-232" />
          <PromoBanner data-id="element-233" />
          <main data-id="element-234">
            <Hero data-id="element-235" />
            <PacksSection data-id="element-236" />
            <CutsSlider data-id="element-237" />
            <ProductCatalog data-id="element-238" />
            <KnowYourCut data-id="element-239" />
          </main>
          <Footer data-id="element-240" />
          <Cart data-id="element-241" />
        </div>
      </CartProvider>
    </ThemeProvider>;
}